module.exports = __webpack_public_path__ + "img/pic01.ad8181a4.png";